// extracted by mini-css-extract-plugin
export default {"red":"Provider_red_GYvim"};